import { useState } from "react";
import { AddBrandDialog } from "./add-brand-dialog";
import { EditBrandDialog } from "./edit-brand-dialog";
import { DeleteBrandDialog } from "./delete-brand-dialog";
import BrandsTable from "./brands-table";
import type { ProductBrand } from "@/types/products/api-types/product-brand-types";

export const BrandsTabContent = () => {
  const [selectedBrand, setSelectedBrand] = useState<ProductBrand | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [brandToDelete, setBrandToDelete] = useState<ProductBrand | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleBrandClick = (brand: ProductBrand) => {
    setSelectedBrand(brand);
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = (open: boolean) => {
    setIsEditDialogOpen(open);
    if (!open) {
      setSelectedBrand(null);
    }
  };

  const handleDeleteClick = (brand: ProductBrand) => {
    setBrandToDelete(brand);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = (open: boolean) => {
    setIsDeleteDialogOpen(open);
    if (!open) {
      setBrandToDelete(null);
    }
  };

  return (
    <div className="mt-5">
      <div className="flex justify-end mb-4 pr-4">
        <AddBrandDialog />
      </div>
      <BrandsTable
        onBrandClick={handleBrandClick}
        onDeleteClick={handleDeleteClick}
      />
      {selectedBrand && (
        <EditBrandDialog
          brand={selectedBrand}
          open={isEditDialogOpen}
          onOpenChange={handleEditDialogClose}
        />
      )}
      {brandToDelete && (
        <DeleteBrandDialog
          brand={brandToDelete}
          open={isDeleteDialogOpen}
          onOpenChange={handleDeleteDialogClose}
        />
      )}
    </div>
  );
};
